module.exports = __webpack_public_path__ + "img/share.381e6cc2.svg";